import React from 'react';
import { Animated, StyleSheet, View } from 'react-native';

import { useManageWizardStepTransition } from './hooks/useManageWizardStepTransition';

export type WizardStepTransitionProps = {
  stepKey: number;
  children: React.ReactNode;
};

const WizardStepTransition = ({ stepKey, children }: WizardStepTransitionProps) => {
  const { activeSlot, content, opacityA, opacityB, translateA, translateB } = useManageWizardStepTransition({
    stepKey,
    children,
  });

  return (
    <View style={{ flex: 1 }}>
      <Animated.View
        pointerEvents={activeSlot === 0 ? 'auto' : 'none'}
        style={[
          StyleSheet.absoluteFillObject,
          { opacity: opacityA, transform: [{ translateX: translateA }] },
        ]}
      >
        {content[0].node}
      </Animated.View>
      <Animated.View
        pointerEvents={activeSlot === 1 ? 'auto' : 'none'}
        style={[
          StyleSheet.absoluteFillObject,
          { opacity: opacityB, transform: [{ translateX: translateB }] },
        ]}
      >
        {content[1].node}
      </Animated.View>
    </View>
  );
};

export default WizardStepTransition;
